module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "u-fit-w",
    class: [_vm.isFakeScroll ? 'u-fixed is-fakescroll' : 'u-relative is-stdscroll', (_vm.isLoading > 0) ? 'is-loading' : '', _vm.isTouch ? 'is-touch' : 'is-not-touch', 'is-' + _vm.componentId],
    style: ({
      overflow: _vm.pageHeight ? 'hidden' : ''
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "js-container u-fit-w u-relative",
    style: ({
      height: _vm.pageHeight ? (_vm.pageHeight + 'px') : ''
    })
  }, [_c('app-bg'), _vm._v(" "), (_vm.contentGlobal) ? _c('app-header', {
    staticClass: "u-absolute",
    attrs: {
      "content-global": _vm.contentGlobal,
      "content-page": _vm.contentPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage !== null && _vm.contentGlobal !== null) ? _c(_vm.componentId, {
    tag: "component",
    staticClass: "c-page js-page u-index--1",
    attrs: {
      "content-global": _vm.contentGlobal,
      "content-page": _vm.contentPage,
      "params": _vm.params
    },
    on: {
      "load": _vm._onPageResized
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-align-center u-relative u-index--3 u-marg-b-xl u-hide u-block@md"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo(0)
      }
    }
  }, [_c('img', {
    staticClass: "u-marg-b-xxs",
    attrs: {
      "src": require("../../../assets/icon/icon-mobile--back-to-top.png"),
      "alt": "Top arrow"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-block u-uppercase u-color--gray-ldark t-text--sm t-lspacing--md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.actions.backToTop)
    }
  })])]), _vm._v(" "), (_vm.contentGlobal) ? _c('app-footer', {
    staticClass: "js-footer",
    attrs: {
      "content-global": _vm.contentGlobal
    },
    on: {
      "load": _vm._onFooterResized
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-modal-play"
    }
  }, [(_vm.registerIsOpen && _vm.contentGlobal) ? _c('app-modal-register', {
    staticClass: "u-index--20",
    attrs: {
      "content-global": _vm.contentGlobal,
      "type-slug": _vm.registerTypeSlug,
      "observe-id": _vm.registerObserveId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-modal-video"
    }
  }, [(_vm.videoIsOpen) ? _c('app-modal-video', {
    staticClass: "u-index--20",
    attrs: {
      "type": _vm.videoType,
      "id": _vm.videoId,
      "url": _vm.videoUrl
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-loader",
      "duration": {
        enter: 1300,
        leave: 1300
      }
    }
  }, [(_vm.isLoading !== 0) ? _c('app-loader') : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isChannelLive && !_vm.isWatchNow && _vm.contentGlobal.watchNowActive) ? _c('app-floating-live', {
    attrs: {
      "content-global": _vm.contentGlobal,
      "is-hidden": _vm.width <= 770 || !_vm.isFloatingLiveShown
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26e9105e"}!./src/scripts/components/app-main/template.html
// module id = 895
// module chunks = 0